module.exports = __webpack_public_path__ + "img/collection-weddingRings.06cbd49.webp";